import { memo } from 'react';
import { Breakpoint, useBreakpoint } from '@bonanza-social/moonlight';

import DesktopMainHeader from './DesktopMainHeader';
import MobileMainHeader from './MobileMainHeader';

function MainHeader() {
  const breakpoint = useBreakpoint();

  if (breakpoint === Breakpoint.DESKTOP) {
    return <DesktopMainHeader />;
  }

  return <MobileMainHeader />;
}

export default memo(MainHeader);
